import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`

export const TrackingInfo = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: ${theme.spacing.md};
  gap: ${theme.spacing['2xm']};
`

export const TrackingInfoItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.sm};
`

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${theme.colors.neutral.clear};
`

export const ButtonArea = styled.div`
  display: flex;
  align-items: center;
  padding: ${theme.spacing.sm} ${theme.spacing.xs};
`

export const TrackingButton = styled.button`
  border: none;
  background: transparent;
  display: flex;
  align-items: center;
  padding: 0 ${theme.spacing.sm};
  gap: ${theme.spacing.xs};
  width: 100%;
  height: 30px;

  span {
    font-family: ${theme.typography.family.primary};
    font-size: ${theme.typography.sizes.xs};
    font-weight: ${theme.typography.weight.sm};
    color: ${theme.colors.neutral.high};
  }
`
